import * as React from 'react';
import { ArticleHeading4, ArticleHeading5, ArticleParagraph2, Label, useDeviceType } from '@cian/ui-kit';

import * as styles from './FreshPromoCard.css';

interface IFreshPromoCardProps {
  backgroundImage: string;
  label?: string;
  location: React.ReactNode;
  logoUrl: string;
  newbuildingName: string;
  title: string;
  onClick?(): void;
}

export const FreshPromoCard: React.FC<IFreshPromoCardProps> = ({
  backgroundImage,
  label,
  location,
  logoUrl,
  newbuildingName,
  title,
  onClick,
}) => {
  const isDesktop = useDeviceType() === 'desktop';
  const Heading = isDesktop ? ArticleHeading4 : ArticleHeading5;

  return (
    <article className={styles['container']} onClick={onClick}>
      <div className={styles['card-image']} style={{ backgroundImage: `url(${backgroundImage}` }}>
        <div
          className={styles['logo-url']}
          style={{ backgroundImage: `url(${logoUrl})` }}
          data-testid="FreshPromoCardLogoUrl"
        />
      </div>
      <div className={styles['text-content']}>
        <ArticleParagraph2 data-testid="FreshPromoCardNewbuildingName">{newbuildingName}</ArticleParagraph2>
        <Heading data-testid="FreshPromoCarPromoName">{title}</Heading>
        {location}
      </div>
      {label && (
        <div className={styles['label']}>
          <Label background="overlay-control-default" color="theme-dark">
            {label}
          </Label>
        </div>
      )}
    </article>
  );
};
